export interface GameEntry {
    level               : string;
    originalImage       : string;
    blackAndWhiteImage  : string;
    information         : string;
}
export class LoadedEntry {
    public level               : string;
    public originalImage       : HTMLImageElement;
    public blackAndWhiteImage  : string;
    public information         : string;
    public title               : string;
    public contentUrlName
}

export enum GameState {
    Loading = 0,
    Ready = 1,
    Drawing = 2,
}